module.exports = __webpack_public_path__ + "static/media/keyboardPiano.83a6a475.mp4";